import React from "react";
import { Alert, Box, Flex, TypographyProps } from "@chakra-ui/react";
import { ChakraFAIcon } from "./ui/Icon";

interface Props {
	status: "info" | "warning" | "error";
	children: React.ReactNode;
	my?: number;
	mt?: number;
	mb?: number;
	mx?: number;
	textAlign?: TypographyProps["textAlign"];
	icon?: keyof typeof iconMap;
	"data-testid"?: string;
}

const iconMap = {
	info: "fa-circle-info",
	warning: "fa-triangle-exclamation",
	error: "fa-circle-xmark",
	notice: "fa-bell-exclamation",
};

const backgroundMap = {
	info: "var(--chakra-colors-accent-turquoise-100)",
	warning: "var(--chakra-colors-accent-yellow-100)",
	error: "var(--chakra-colors-accent-red-100)",
};

const iconColorMap = {
	info: "var(--chakra-colors-accent-turquoise-400)",
	warning: "var(--chakra-colors-accent-yellow-400)",
	error: "var(--chakra-colors-accent-red-400)",
};

/**
 * A pure Chakra replacement for FZCL's InlineNotification component.
 */
export function Notice(props: Props): JSX.Element {
	return (
		<Alert
			status={props.status}
			variant="subtle"
			background={backgroundMap[props.status]}
			p={4}
			my={props.my}
			mt={props.mt}
			mb={props.mb}
			mx={props.mx}
			borderRadius={"md"}
			textAlign={props.textAlign}
			data-testid={props["data-testid"]}
		>
			<Flex gap={3}>
				<Box>
					<ChakraFAIcon icon={iconMap[props.icon || props.status]} variant="solid" color={iconColorMap[props.status]} />
				</Box>
				<Box>{props.children}</Box>
			</Flex>
		</Alert>
	);
}
